define.alias("shared/components/shared/page-picker-legacy", "calendar/components/shared/page-picker-legacy");